import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import IndexSectionHeadersLightReverse3 from '../components/headers-light-reverse/IndexSectionHeadersLightReverse3';
import IndexSectionHowItWorksLightReverse6 from '../components/how-it-works-light-reverse/IndexSectionHowItWorksLightReverse6';
import IndexSectionFeaturesLightReverse4 from '../components/features-light-reverse/IndexSectionFeaturesLightReverse4';
import IndexSectionCtaLightReverse5 from '../components/cta-light-reverse/IndexSectionCtaLightReverse5';
import IndexSectionFootersLightReverse2 from '../components/footers-light-reverse/IndexSectionFootersLightReverse2';
import FAQCustomComponent from '../components/custom-components/FAQCustomComponent';
import ContactUsCustomComponent from '../components/custom-components/ContactUsCustomComponent';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <IndexSectionHeadersLightReverse3 />
      <IndexSectionHowItWorksLightReverse6 />
      <IndexSectionFeaturesLightReverse4 />
      <FAQCustomComponent />
      <IndexSectionCtaLightReverse5 />
      <ContactUsCustomComponent />
      <IndexSectionFootersLightReverse2 />
    </React.Fragment>
  );
}

